import React, { useState } from "react";
import { ReactComponent as Cancel } from "../../../Assets/Image/svg/cancel.svg";
import { useForm } from "react-hook-form";
import { ReactComponent as Upload } from "../../../Assets/Image/svg/Upload.svg";
import UploadWithoutModal from "../../share/input/Upload/UploadWithoutModal";
import { BtnPrimary, BtnAlternative } from "../../share/buttons/Btn";
import { AiOutlineUpload } from "react-icons/ai";
import SupportTicketQuill from "../SupportTicket/SupportTicketQuill";

function PollModal({ close }) {
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => console.log("data", data);
  const [step, setStep] = useState(0);
  const nextPage = () => {
    setStep(1);
  };
  const pervPage = () => {
    setStep(0);
  };
  return (
    <div className="AddnewsupportTicket relative">
      {" "}
      <button
        onClick={() => close(false)}
        className="AddnewsupportTicket-cancel absolute  "
      >
        <div>
          <Cancel />
        </div>
      </button>
      <p className=" text-[#77498F] text-[2rem] leading-[3.2rem] font-bold text-center">
        نظر سنجی پایان دوره
      </p>
      <form onSubmit={handleSubmit(onSubmit)}>
        {step === 0 ? (
          <div className=" mt-[3.1rem] w-[73.2rem]">
            <p className=" text-[#212121] font-normal leading-[3.2rem] text-[1.8rem] text-right">
              1- این دوره را چگونه ارزیابی میکنید؟
            </p>

            <div className=" flex items-center justify-start mt-[1.2rem]">
              <label
                htmlFor="weak"
                className=" text-[#212121E5] text-[1.4rem] leading-[2.4rem] font-normal flex flex-row items-center"
              >
                <input
                  {...register("course", { required: true })}
                  type="radio"
                  name="course"
                  value="weak"
                  className="form-check-input PriceForm radio-lg ml-[0.8rem]"
                  id="weak"
                />{" "}
                ضعیف
              </label>
            </div>
            <div className=" flex items-center justify-start mt-[1.2rem]">
              <label
                htmlFor="medium"
                className=" text-[#212121E5] text-[1.4rem] leading-[2.4rem] font-normal flex flex-row items-center"
              >
                <input
                  {...register("course", { required: true })}
                  type="radio"
                  name="course"
                  value="medium"
                  className="form-check-input PriceForm radio-lg ml-[0.8rem]"
                  id="medium"
                />{" "}
                متوسط
              </label>
            </div>
            <div className=" flex items-center justify-start mt-[1.2rem]">
              <label
                htmlFor="strong"
                className=" text-[#212121E5] text-[1.4rem] leading-[2.4rem] font-normal flex flex-row items-center"
              >
                <input
                  {...register("course", { required: true })}
                  type="radio"
                  name="course"
                  value="strong"
                  className="form-check-input PriceForm radio-lg ml-[0.8rem]"
                  id="strong"
                />{" "}
                قوی
              </label>
            </div>
            <div className=" flex items-center justify-start mt-[1.2rem]">
              <label
                htmlFor="ordinary"
                className=" text-[#212121E5] text-[1.4rem] leading-[2.4rem] font-normal flex flex-row items-center"
              >
                <input
                  {...register("course", { required: true })}
                  type="radio"
                  name="course"
                  value="ordinary"
                  className="form-check-input PriceForm radio-lg ml-[0.8rem]"
                  id="ordinary"
                />{" "}
                معمولی
              </label>
            </div>
            <div className=" mt-[1.6rem]">
              <p className=" text-[#212121] font-normal leading-[3.2rem] text-[1.8rem] text-right mb-[1.6rem]">
                2- فایل رزومه خود را آپلود کنید:
              </p>
              <UploadWithoutModal
                label={"بارگذاری"}
                icon={
                  <AiOutlineUpload className=" text-[#21212199] w-[1.8rem] text-[1.8rem] " />
                }
              />
            </div>

            <div className=" text-left mt-[9.3rem]">
              <BtnPrimary
                text="ثبت و ادامه"
                className="px-16 py-7"
                onClick={nextPage}
              />
            </div>
          </div>
        ) : (
          <div className=" mt-[3.1rem]">
            <p className=" text-[#212121] font-normal leading-[3.2rem] text-[1.8rem] text-right mb-[1.2rem]">
              3- نقاط ضعف این دوره را نام ببرید:{" "}
            </p>
            <SupportTicketQuill placeholder="توضیحات کلی*" />
            <div className=" mt-[9.3rem] flex flex-row items-center justify-between">
              <BtnAlternative
                text="صفحه قبل"
                className="px-10 py-6 self-center"
                onClick={pervPage}
              />
              <BtnPrimary
                text="ثبت و ادامه"
                className="px-16 py-7"
                onClick={nextPage}
              />
            </div>
          </div>
        )}
      </form>
    </div>
  );
}

export default PollModal;
